"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLoginDto = instanceOfLoginDto;
exports.LoginDtoFromJSON = LoginDtoFromJSON;
exports.LoginDtoFromJSONTyped = LoginDtoFromJSONTyped;
exports.LoginDtoToJSON = LoginDtoToJSON;
exports.LoginDtoToJSONTyped = LoginDtoToJSONTyped;
/**
 * Check if a given object implements the LoginDto interface.
 */
function instanceOfLoginDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function LoginDtoFromJSON(json) {
    return LoginDtoFromJSONTyped(json, false);
}
function LoginDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
    };
}
function LoginDtoToJSON(json) {
    return LoginDtoToJSONTyped(json, false);
}
function LoginDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
    };
}
